import { textFormatter } from "../../../../utils/formatter/formatter";

import { 
  getStepCols, 
  FilterSection,
  SelectionSection
} from "../shared";

import { PerformanceAnalysis } from "./components/PerformanceAnalysis";

export const EstimatesTab = ({ actions, ctx, uiState }) => {

  const { 
    setEstimatesFilters, 
    clearEstimatesFilters, 
    setSelectedProduct, 
    setOnlyWithSimilars 
  } = actions || {};

  const { 
    filterOptions, 
    products, 
    productIndicatorData, 
    tenantHierarchy,
    estimatesSeasonOptions,
    allSeasons,
    productImageData
  } = ctx || {};

  const { 
    estimatesFilters, 
    estimatesSeason, 
    selectedProduct = false, 
    userSelectedProductId,
    onlyWithSimilars,
    isLoadingProductImage
  } = uiState || {};  

  const currentDevelopmentSeason = textFormatter(
    estimatesSeasonOptions.find((season) => season?.value === estimatesSeason)?.label,
    {
      textTransform: 'uppercase'
    }
  );
  

  const cols = getStepCols(true, !!selectedProduct);

  const isTypeSelected = (item, selected) => 
    !!userSelectedProductId && item.attributePerformanceMatrixId === userSelectedProductId;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12, flex: 1, minHeight: 0 }}>
      <section 
        style={{ 
          backgroundColor: "#fff", 
          border: "1px solid #e5e5e5",
          borderRadius: "12px", 
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          overflow: "hidden",
          padding: "16px 20px", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between", 
          flexShrink: 0 }}>
        <hgroup>
          <h5 style={{ fontWeight: "700", color: "#1a1a1a" }}>
            Estimativas de Performance
          </h5>

          <p style={{ fontSize: "0.75rem", color: "#aaa", marginTop: 2 }}>
            Estimativa de performance baseada na similaridade dos produtos
          </p>          
        </hgroup>

        <p style={{ fontSize: "0.875rem", color: "#aaa", marginTop: 2 }}>
          {`Coleção atual em Desenvolvimento: `}
          {/* <strong style={{ color: 'rgba(237, 112, 29' }} >{`${currentDevelopmentSeason}`}</strong> */}
          <strong style={{ color: 'rgba(237, 112, 29' }} >{'PRIMAVERA 2027'}</strong>
        </p>
      </section>

      <div style={{ display: "grid", gridTemplateColumns: cols, gap: "12px", flex: 1, minHeight: 0 }}>
        <FilterSection
          actions={{ setFilters: setEstimatesFilters, clearFilters: clearEstimatesFilters }}
          ctx={{ filterOptions: filterOptions }}
          uiState={{ 
            filters: estimatesFilters, 
            total: filterOptions?.hierarquia?.Tipo.length,
            label: "produtos",
            stepTitle: "Filtro de Produto"
          }}/>
        
        <SelectionSection
          actions={{ onSelect: setSelectedProduct, onToggleSimilars: setOnlyWithSimilars }}
          ctx={{
            items: products,
            title: "Selecione o Produto",
            isSelected: isTypeSelected,
          }}
          uiState={{ 
            selectedItem: selectedProduct, 
            onlyWithSimilars: onlyWithSimilars,
            mode: 'performance_mode'
          }}/>
        
        {!!selectedProduct && (
          <PerformanceAnalysis
            ctx={{ 
              productIndicatorData: productIndicatorData, 
              allSeasons: allSeasons,
              tenantHierarchy: tenantHierarchy,
              selectedProduct: selectedProduct,
              productImageData: productImageData,
              isLoadingProductImage: isLoadingProductImage,
            }}
          />
        )}
      </div>
    </div>
  );
};